import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AdminDto } from '../dtos/admin.dto';
import { environment } from '../../../../environments/environment';
import { MemoryService } from '../../../core/services/memory.service';
import { QueryAdminsDto } from '../dtos/query-admins.dto';
import { Observable } from 'rxjs';
import { UpdateAdminTypeDto } from '../dtos/update-admin-type.dto';
import { RegisterAdminLegacyDto } from '../dtos/register-admin-legacy.dto';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(private http: HttpClient, private memoryService: MemoryService) {
  }

  queryAdmins(queryAdminsDto: QueryAdminsDto): Observable<AdminDto[]> {
    return this.http.post<AdminDto[]>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.memoryService.customerId}/admins/query`, queryAdminsDto);
  }

  registerAdmin(adminDto: AdminDto): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.memoryService.customerId}/admins/register`, adminDto);
  }

  updateAdminType(updateAdminTypeDto: UpdateAdminTypeDto): Observable<void> {
    return this.http.put<void>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.memoryService.customerId}/admins/type`, updateAdminTypeDto);
  }

  registerAdminLegacy(customerId: number, registerAdminLegacyDto: RegisterAdminLegacyDto): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/customers/${customerId}/admins/register/legacy`, registerAdminLegacyDto);
  }
}
